import React, { useState, useEffect } from "react";
import { Box, ListItem, CircularProgress } from "@mui/material";
import AudioPlayer from "../../../Archive/audioWrap/AudioPreview";
import { populateWithPresignedURL } from "../../../../api/datapoint"

const MediaComponent = ({ file, schema, status, handleRedoClick }) => {
  const [mediaUrl, setMediaUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMediaSource = async () => {
      try {
        setLoading(true);
        if (status === "online") {
          const presignedUrl = await populateWithPresignedURL(file);
          setMediaUrl(presignedUrl);
        } else {
          setMediaUrl(URL.createObjectURL(file.file));
        }
      } catch (error) {
        console.error('Error loading media:', error);
      } finally {
        setLoading(false);
      }
    };

    loadMediaSource();
  }, [file, status]);

  if (loading) {
    return (
      <ListItem style={{ marginBottom: "16px", justifyContent: "center" }}>
        <CircularProgress size={24} />
      </ListItem>
    );
  }

  return (
    <ListItem style={{ marginBottom: "16px" }}>
      {file && (schema?.media === "camera" || schema?.media === "file") && (
        <Box>
          <img
            src={mediaUrl}
            alt={file.name}
            style={{
              maxWidth: "100%",
              maxHeight: "150px",
              marginTop: "10px",
            }}
          />
        </Box>
      )}
      {file && schema?.media === "audio" && (
        <AudioPlayer
          audioFile={mediaUrl}
          duration={file.duration}
          redoFunction={handleRedoClick}
          showSave={false}
          showControl={true}
          handleSave={null}
          sliderColor="success"
        />
      )}
      {file && schema?.media === "video" && (
        <video
          src={mediaUrl}
          controls
          style={{
            width: "250px",
            maxHeight: "150px",
            marginTop: "20px",
          }}
        />
      )}
    </ListItem>
  );
};

export default MediaComponent;
